import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { CompleteMSOResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export interface CompleteMSOInput {
	msoCompleteScan: {
		base64Data: string;
		type?: string;
		name?: string;
	};
}

export const completeMSO = async (
	servicesProviderId: string,
	orderId: string,
	data: CompleteMSOInput,
): Promise<CompleteMSOResponse> => {
	const response = await apiClient.post<CompleteMSOResponse>(
		ordersEndpoints.completeMSO(servicesProviderId, orderId),
		data,
	);
	return response.data;
};

export const useCompleteMSO = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (input: CompleteMSOInput) => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to complete MSO without an order ID or services provider ID.',
				);
			}

			return completeMSO(servicesProviderId, orderId, input);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.COMPLETE_MSO);
		},
	});
};
